import { X } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Input } from '@/components/ui/input'
import { mergeSeedDraft } from '@/lib/seeds'
import type { SeedInputProps } from './SeedInput.types'

export function SeedInput({
  id,
  values,
  draft,
  helperText,
  disabled,
  onValuesChange,
  onDraftChange,
}: SeedInputProps) {
  function commitDraft() {
    if (!draft.trim()) return

    onValuesChange(mergeSeedDraft(values, draft))
    onDraftChange('')
  }

  function removeSeed(seed: string) {
    onValuesChange(values.filter((value) => value !== seed))
  }

  return (
    <div className="space-y-2">
      <Input
        id={id}
        value={draft}
        onChange={(e) => onDraftChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ',') {
            e.preventDefault()
            commitDraft()
          }
        }}
        onBlur={commitDraft}
        placeholder="Spaces like durability, sizing, or price"
        disabled={disabled}
      />

      {values.length > 0 && (
        <div className="flex flex-wrap gap-1.5">
          {values.map((seed) => (
            <Badge key={seed} variant="secondary" className="gap-1 pr-1">
              {seed}
              <button
                type="button"
                onClick={() => removeSeed(seed)}
                className="ml-0.5 rounded-full p-0.5 hover:bg-muted focus-visible:outline-none focus-visible:ring-ring/50 focus-visible:ring-[3px]"
                aria-label={`Remove ${seed}`}
              >
                <X className="size-3" />
              </button>
            </Badge>
          ))}
        </div>
      )}

      {helperText && (
        <p className="text-xs text-muted-foreground">{helperText}</p>
      )}
    </div>
  )
}
